import React from "react";
import MainCP  from "../../Components/CrearGraphDinamic/MainCP"

const ViewCarga: React.FC = () => <MainCP/>

export default ViewCarga;